//const API_BASE_URL = 'https://sdss-dev.shcl.co.kr'; //개발계
//const API_BASE_URL = 'https://sdss.shcl.co.kr'; //운영계

const API_BASE_URL = ''; // Proxy to localhost:3001 via package.json

module.exports = {
    API_BASE_URL
};
